import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

const VerifyEmail = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('checking'); // checking | ok | error

  useEffect(() => {
    axios.post(`/api/auth/verify-email/${token}`)
      .then(() => setStatus('ok'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-neutral-50 to-neutral-100 p-6">
      <div className="w-full max-w-md">
        <div className="bg-white border border-neutral-200/70 rounded-2xl shadow-[0_18px_50px_-20px_rgba(15,23,42,0.28)] p-8 sm:p-9 text-center">
          {status === 'checking' && (
            <>
              <Loader2 size={28} className="text-primary-600 animate-spin mx-auto mb-4" />
              <h2 className="text-lg font-semibold text-neutral-900">Verifying your email…</h2>
            </>
          )}
          {status === 'ok' && (
            <>
              <div className="w-12 h-12 rounded-xl bg-success-50 text-success-600 flex items-center justify-center mb-4 ring-1 ring-success-100 mx-auto">
                <CheckCircle2 size={22} />
              </div>
              <h2 className="text-xl font-bold text-neutral-900 tracking-tight">Email verified</h2>
              <p className="text-sm text-neutral-500 mt-2">You're all set.</p>
            </>
          )}
          {status === 'error' && (
            <>
              <div className="w-12 h-12 rounded-xl bg-danger-50 text-danger-600 flex items-center justify-center mb-4 ring-1 ring-danger-100 mx-auto">
                <XCircle size={22} />
              </div>
              <h2 className="text-xl font-bold text-neutral-900 tracking-tight">Link expired or invalid</h2>
              <p className="text-sm text-neutral-500 mt-2">Log in and request a new verification email from your account.</p>
            </>
          )}
          <p className="text-sm text-neutral-500 mt-6">
            <Link to="/login" className="text-primary-600 font-medium hover:text-primary-700">Go to sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
